// extracted by mini-css-extract-plugin
export default {"box":"gIMdtuLRLGYnq2V_HwpWC","title":"_1rlRnafcQCFHIgZ36DTMLt","content":"_1YqG6pGfHNltv_cLmx6WaM","hideContent":"_1Ztz6NVZrY9JT-1Wi5wdpz"};